class WishlistManager {
  constructor() {
    this.storageKey = 'theme_wishlist';
    this.items = this.load();
  }

  load() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  save() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    this.updateCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: this.items } }));
  }

  has(handle) {
    return this.items.includes(handle);
  }

  add(handle) {
    if (!this.has(handle)) {
      this.items.push(handle);
      this.save();
    }
  }

  remove(handle) {
    this.items = this.items.filter((h) => h !== handle);
    this.save();
  }

  toggle(handle) {
    if (this.has(handle)) {
      this.remove(handle);
      return false;
    }
    this.add(handle);
    return true;
  }

  updateCount() {
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = this.items.length;
    });
    document.querySelectorAll('[data-wishlist-count-holder]').forEach((el) => {
      el.classList.toggle('is-empty', this.items.length === 0);
    });
  }
}

window.wishlist = new WishlistManager();

class WishlistButton extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.productHandle;
    this.button = this.querySelector('button');
    this.updateState();

    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.wishlist.toggle(this.handle);
      this.updateState();
    });

    this._onUpdate = () => this.updateState();
    document.addEventListener('wishlist:updated', this._onUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('wishlist:updated', this._onUpdate);
  }

updateState() {
  const active = window.wishlist.has(this.handle);
  this.classList.toggle('is-active', active);
  this.button.classList.toggle('is-active', active);
  this.button.setAttribute('aria-pressed', active);
  this.button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  // path.style.fill wali lines REMOVE kardo — CSS ab control karti hai
}
}

customElements.define('wishlist-button', WishlistButton);

document.addEventListener('DOMContentLoaded', () => {
  window.wishlist.updateCount();
});